import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/* eslint-disable max-len, react/prop-types */
var ThumbsDown = function ThumbsDown() {
  return /*#__PURE__*/_jsxs("svg", {
    "aria-hidden": "true",
    role: "presentation",
    height: "26",
    width: "26",
    children: [/*#__PURE__*/_jsx("title", {
      children: "Thumbs Down Icon"
    }), /*#__PURE__*/_jsx("use", {
      href: "#thumbs-down"
    })]
  });
};

export default ThumbsDown;